import React from 'react';

import Me from '../assets/images/me.jpg';
import '../assets/css/Content.css';

function Main() {
  return (
    <div className="container mt-4">
      <div className="content">
        <div className="content--left d-flex col">
          <section className="content__paragraph flex-1">
            <p>
              I'm nothing, but trash..<br />
              but I didn't giving up!<br />
              because of that'll make me powerfull
            </p>
          </section>
          <hr className="line-break" />

          <section className="content__specialize flex-1">
            <h3 className="content__title">Specialize</h3>
            <div className="content__skills d-flex wrap">
              <div className="content__skill-content">UI</div>
              <div className="content__skill-content">UX</div>
              <div className="content__skill-content">CSS</div>
              <div className="content__skill-content">HTML</div>
              <div className="content__skill-content">React Native</div>
              <div className="content__skill-content">React JS</div>
              <div className="content__skill-content">Figma</div>
            </div>
          </section>
          <hr className="line-break" />

          <section className="content__social flex-1">
            <h3 className="content__title">Get In Touch</h3>
            <div className="content__social-list d-flex wrap">
              <a href="https://github.com/hikimo" className="content__social-content">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://dribbble.com/hikidev" className="content__social-content">
                <i className="fab fa-dribbble"></i>
              </a>
              <a href="https://www.instagram.com/rangga_prastio/" className="content__social-content">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/rangga.prastio.79" className="content__social-content">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.linkedin.com/in/hikidev/" className="content__social-content">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </section>
        </div>
        <div className="content--right d-flex col center">
          <div className="content__card active">
            <div className="container d-flex col center">
              <div className="content__profile-img">
                <img src={Me} alt="my profile" />
              </div>
              <div className="content__profile-desc">
                <h1 className="content__profile-name">Rangga Prastio</h1>
                <span className="content__profile-subject">Fullstack Engineer</span>
                <div className="content__profile-bio">
                  <p>
                    A Fullstack-Engiineer and a Freelancer who love to design
                    and code, commonly working at creating website page. Well
                    experienced at Front-End based work.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="content__card">
            <div className="container d-flex col center">
              <div className="content__profile-img">
                <img src={Me} alt="my profile" />
              </div>
              <div className="content__profile-desc">
                <h1 className="content__profile-name">Rangga Prastio</h1>
                <span className="content__profile-subject">Fullstack Engineer</span>
                <div className="content__profile-bio">
                  <p>
                    A Fullstack-Engiineer and a Freelancer who love to design
                    and code, commonly working at creating website page. Well
                    experienced at Front-End based work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
